































import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { generalDialogMixin, elementWidth } from '@/mixins'
import easyapi from '@/easyapi'
import { extender_vendor_t } from '@/types/api'
import VwResizePreview from '@/components/VwResizePreview.vue'
import { VW_MAX_COLUMNS, VW_MAX_ROWS } from '@/vw_algorithm'

export default mixins(generalDialogMixin, elementWidth).extend({
  components: {
    VwResizePreview
  },
  data (): {
    newName: string,
    columns: number,
    rows: number,
    vendor: extender_vendor_t,
    VENDOR_OPTIONS: Array<{key: extender_vendor_t, label: string}>
  } {
    return {
      newName: '',
      columns: 2,
      rows: 2,
      vendor: 'Aspeed',
      VENDOR_OPTIONS: [
        {key: 'Aspeed', label: this.$t('model.hg') as string},
        {key: 'Aptovision', label: this.$t('model.hx') as string}
      ]
    }
  },
  computed: {
    newNameDuplicated (): boolean { return this.$s.device.getters.vwList.some(x => x.name === this.newName) },
    invalid (): boolean { return !this.newName || this.newNameDuplicated }
  },
  methods: {
    addCol (x: number) {
      const tmp = this.columns + x
      if (tmp > VW_MAX_COLUMNS) { this.columns = VW_MAX_COLUMNS; return }
      if (tmp < 1) { this.columns = 1; return }
      this.columns = tmp
    },
    addRow (x: number) {
      const tmp = this.rows + x
      if (tmp > VW_MAX_ROWS) { this.rows = VW_MAX_ROWS; return }
      if (tmp < 1) { this.rows = 1; return }
      this.rows = tmp
    },
    async apply () {
      const ok = await easyapi.createVw({
        id: -1,
        enabled: false,
        vendor: this.vendor,
        name: this.newName,
        displayIndex: false,
        layout: {
          columns: this.columns,
          rows: this.rows,
        },
        rxList: [],
        txList: []
      })
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  watch: {
  },
  mounted () {
    this.watchElementWidth('vwPreviewContainer')
  }
})
